import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import FilterPanel from '../../components/ui/FilterPanel';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { getDefaultEnterprisePath } from '../../access/userAccess';

export default function CrmConfiguration() {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Configuration - CRM</title>
      </Helmet>
      <Header />
      <Breadcrumb />
      <FilterPanel />

      <main className="main-content max-w-lg">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-foreground mb-1">Configuration</h1>
          <p className="text-sm text-muted-foreground">
            Les réglages globaux du workspace (dont Stancer) se gèrent dans l&apos;application
            Gestion entreprise.
          </p>
        </div>

        <section className="rounded-xl border border-border bg-card p-5 space-y-4">
          <div className="flex items-center gap-2">
            <Icon name="Building2" size={20} className="text-primary" />
            <h2 className="font-semibold text-foreground">Paiement Stancer</h2>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Configurez les clés publique et privée Stancer par entreprise dans{' '}
            <strong className="font-medium text-foreground">Paramètres</strong> de la gestion
            d&apos;entreprise. Elles s&apos;appliquent au CRM (campagnes, produits) et sont
            synchronisées vers HubUP lorsqu&apos;une communauté est liée.
          </p>
          <Button asChild variant="outline" size="sm">
            <Link to={getDefaultEnterprisePath()}>Ouvrir gestion entreprise</Link>
          </Button>
        </section>
      </main>
    </div>
  );
}
